import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { PageHeader, EmptyState, Spinner } from "../../components/dashboard/DashboardShell";
import InspectorCard from "../../components/pengguna/InspectorCard";
import { Button } from "../../components/ui/button";

export default function FavoritesPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["favorites"], queryFn: () => api.get("/users/me/favorites").then((r) => r.data) });
  return (
    <div>
      <PageHeader title="Inspector Favorit" subtitle="Inspector yang Anda simpan untuk dipesan kembali." />
      {isLoading ? <Spinner /> : !data?.length ? (
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm">
          <EmptyState icon="heart" title="Belum ada favorit" desc="Tekan ikon hati pada profil inspector untuk menyimpannya."
            action={<Button onClick={() => navigate("/pengguna/cari")} className="bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl text-sm">Cari Inspector</Button>} />
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="favorites-grid">{data.map((i) => <InspectorCard key={i.user_id} insp={i} />)}</div>
      )}
    </div>
  );
}
